import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

private static requestsList: {id:number; destination: string; hadResponse: boolean}[] = [];

constructor() {}

  public static showLoader() {
      document.getElementById('loading-bar-spinner-component').classList.remove('d-none');
    }
    public static hideLoader() {
      document.getElementById('loading-bar-spinner-component').classList.add('d-none');
    } 


  public static MakeRequest(destination: string){
    this.showLoader();
    let id = this.requestsList.length + 1;
    this.requestsList.push({id: id, destination: destination, hadResponse: false });
    // console.log("Add",JSON.stringify(this.requestsList));
  }

  public static HadResponse(destination: string){
    if (destination) {
      this.requestsList.filter(r => r.destination === destination)[0].hadResponse = true;

        if (this.GetNumberOfRunningRequests() === 0) {
          this.hideLoader();
        }
      }
    // console.log("remove",JSON.stringify(this.requestsList));
  }

  public static GetNumberOfRunningRequests(): number {
    let runningRequests = Array<{id:number; destination: string; hadResponse: boolean}>();
    runningRequests = this.requestsList.filter(r => r.hadResponse === false);

      if (runningRequests) {
        return runningRequests.length;
      } 
  }

}
